import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { GoogleChartInterface } from "ng2-google-charts/google-charts-interfaces";
import { TranslateService } from "@ngx-translate/core";
// import { Http, RequestOptions, Headers } from "@angular/http";
// import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  // LoadingController,
  NavParams,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-stat-shopper",
  templateUrl: "merchant-stat-shopper.html",
})
export class MerchantStatShopperPage {
  round: "";
  total_unit_sold = {
    total_unit_sold: "",
    plazas: [
      {
        plaza_id: "",
        plaza_name: "",
        unit_sold: "",
      },
    ],
  };

  total_revenue = {
    total_revenue: "",
    plazas: [
      {
        plaza_id: 1,
        plaza_name: "",
        revenue: "",
      },
    ],
  };

  shopper_type = [
    {
      shopper_id: "",
      shopper_name: "",
      shopper_code: "",
      unit_bought: 0,
      bought_price: 0,
    },
  ];

  // PieChartdataTable = [
  //   ["PLAZA A", 0],
  //   ["PLAZA B", 0],
  //   ["PLAZA C", 0],
  // ];

  // PieChartdataTable2 = [
  //   ["PLAZA A", 0],
  //   ["PLAZA B", 0],
  //   ["PLAZA C", 0],
  // ];

  // PieChartdataTable3 = [
  //   ["CELEB", 0],
  //   ["OFFICE", 0],
  //   ["FAMILY", 0],
  //   ["FOREIGNER", 0],
  //   ["ELDER", 0],
  //   ["TEENAGE", 0],
  // ];

  // PieChartdataTable4 = [
  //   ["CELEB", 0],
  //   ["OFFICE", 0],
  //   ["FAMILY", 0],
  //   ["FOREIGNER", 0],
  //   ["ELDER", 0],
  //   ["TEENAGE", 0],
  // ];

  // unit_sold: any;
  // revenue: any;
  // shoppee_type: any;
  spending: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    // private services: ServiceProvider,
    // private http: Http,
    public translateService: TranslateService,
    // private loadingCtrl: LoadingController,
    public navParams: NavParams
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log("stat_unit_sold===>", this.navParams.data.stat_unit_sold);
    this.total_unit_sold = this.navParams.data.total_unit_sold;
    // console.log("revenue===>", this.navParams.data.revenue);
    this.total_revenue = this.navParams.data.total_revenue;
    this.shopper_type = this.navParams.data.shopper_type;
    // this.spending = this.navParams.data.stat_spending;

    // this.pieChart.dataTable = this.unit_sold;
    // this.pieChart2.dataTable = this.revenue;
    // this.pieChart3.dataTable = this.shoppee_type;
    // this.pieChart4.dataTable = this.spending;

    // const loader = this.loadingCtrl.create({
    //   content: "Loading...",
    // });
    // loader.present();

    // this.storage.get("roundGame").then((round) => {
    //   this.round = round;
    // });
    // this.storage.get("token").then((token) => {
    //   var link = this.services.URLMerchantStatUnit;
    //   var headers = new Headers();
    //   headers.append("Accept", "application/json");
    //   headers.append("Authorization", "Bearer " + token);
    //   const requestOptions = new RequestOptions({ headers: headers });

    //   this.http
    //     .get(link, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         this.total_unit_sold = data;
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);

    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );

    //   var link2 = this.services.URLMerchantRevenue;
    //   this.http
    //     .get(link2, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         this.total_revenue = data;
    //         // console.log("total_revenue=", this.total_revenue);
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);

    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );

    //   var link3 = this.services.URLMerchantShopperType;
    //   this.http
    //     .get(link3, requestOptions)
    //     .map((res) => res.json())
    //     .subscribe(
    //       (data) => {
    //         this.shopper_type = data;
    //         // console.log("shopper_type=", this.shopper_type);
    //       },
    //       (error) => {
    //         var response = JSON.parse(error._body);

    //         this.translateService.get(response.message).subscribe((value) => {
    //           this.services.presentToast(value);
    //         });
    //       }
    //     );
    // });

    // loader.dismiss();
  }

  public pieChart: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: this.navParams.data.stat_unit_sold,
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        //  textStyle: {color: '#d59237', fontSize: 10},
        //  alignment: 'center',
        //  maxLines: 2
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 5,
        bottom: 5,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: ["#4aa349", "#305daa", "#e2a83d", "#009482"],
      animation: {
        duration: 1000,
      },
    },
  };

  public pieChart2: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: this.navParams.data.stat_revenue,
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237', fontSize: 10},
        // alignment: 'center',
        // maxLines: 2
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 5,
        bottom: 5,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: ["#4aa349", "#305daa", "#e2a83d", "#009482"],
      animation: {
        duration: 1000,
      },
    },
  };

  public pieChart3: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: this.navParams.data.stat_shoppee_type,
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237', fontSize: 10},
        // alignment: 'center',
        // maxLines: 2
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 5,
        bottom: 5,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: [
        "#efa646",
        "#3d8a43",
        "#3d4c9f",
        "#aa4f9e",
        "#EE5435",
        "#FF69B4",
      ],
      animation: {
        duration: 1000,
      },
    },
  };

  public pieChart4: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: this.navParams.data.stat_spending,
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237', fontSize: 10},
        // alignment: 'center',
        // maxLines: 2
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 5,
        bottom: 5,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: [
        "#efa646",
        "#3d8a43",
        "#3d4c9f",
        "#aa4f9e",
        "#EE5435",
        "#FF69B4",
      ],
      animation: {
        duration: 1000,
      },
    },
  };

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-stat-shopper/merchant-stat-shopper.ts